import React from 'react';
import { IoSparklesSharp } from "react-icons/io5";

const SuggestionList = ({ suggestions, onSuggestionClick }) => {
  if (!suggestions || suggestions.length === 0) {
    return null;

  }
  const text = suggestions[0]
  const isMobile = window.innerWidth <= 1000;  // Check if the screen size is mobile
  const isArabicText = (text) => /[\u0600-\u06FF]/.test(text);
  const isArabic = isArabicText(text); // Check if the text is Arabic
  const fontSize = isMobile ? '0.8rem' : '0.9rem'; // Adjust as needed
  return (
    <div className={`suggestion-list ml-14 flex flex-wrap gap-2 mt-10 ${isArabic?"justify-end mr-5":"justify-start"} mb-0`}> {/* Removed bottom margin */}
      {suggestions.map((suggestion, index) => (
        <div
          key={index}
          className={`border border-[#007560] rounded-lg px-4 py-2 text-[#007560] text-center cursor-pointer hover:bg-[#f0fdf9] flex items-center`}
          style={{ fontSize , direction: isArabic ? "rtl" : "ltr", }} // Inline style for smaller font size
          onClick={() => onSuggestionClick(suggestion)} // Call the function when clicked
        >
          <IoSparklesSharp className={`${isArabic?"ml-2":"mr-2"}`}style={{ color: '#007560' }} /> {/* Add the icon and match its color */}
          {suggestion}
        </div>
      ))}
    </div>
  );
};

export default SuggestionList;
